import { render, staticRenderFns } from "./ShareProjectModal.vue?vue&type=template&id=0ed59353&scoped=true"
import script from "./ShareProjectModal.vue?vue&type=script&lang=js"
export * from "./ShareProjectModal.vue?vue&type=script&lang=js"
import style0 from "./ShareProjectModal.vue?vue&type=style&index=0&id=0ed59353&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed59353",
  null
  
)

export default component.exports